import { useState } from 'react';
// @ts-ignore
import Notify from 'store/utils/Notify';
import { fetchClustersRequest, uploadProjectRequest } from '../../api';

export default () => {
  const [isUploadingAndDeploying, setIsUploadingAndDeploying] = useState(false);
  const [isLoadingClusters, setLoadingClusters] = useState(false);
  const [clusters, setClusters] = useState<string[]>([]);
  const [uploadAndDeployError, setUploadAndDeployError] = useState(false);
  const [authenticate, setAuthenticate] = useState(false);
  const [uploadAndDeployData, setUploadAndDeployData] = useState<{
    environmentId: string;
    password: string;
    app_name: string;
    description?: string;
  }>();

  const resetModal = () => {
    setUploadAndDeployError(false);
    setUploadAndDeployData(undefined);
    setLoadingClusters(false);
    setClusters([]);
    setAuthenticate(false);
    setIsUploadingAndDeploying(false);
  };

  const fetchClusters = async ({
    environmentId,
    password,
  }: {
    environmentId: string;
    password: string;
    description?: string;
  }) => {
    setLoadingClusters(true);
    try {
      const {
        data: { clusters },
      } = await fetchClustersRequest(environmentId, password);

      setClusters(clusters);
    } finally {
      setLoadingClusters(false);
    }
  };

  const setAuthenticatingStatus = (value: boolean) => {
    setAuthenticate(value);
  };

  const uploadAndDeployProject = async (cluster: string): Promise<boolean> => {
    if (uploadAndDeployData) {
      setIsUploadingAndDeploying(true);
      try {
        await uploadProjectRequest(uploadAndDeployData!.environmentId, {
          password: uploadAndDeployData!.password,
          description: uploadAndDeployData
            ? uploadAndDeployData.description
            : undefined,
          app_name: uploadAndDeployData!.app_name,
          deploy_to: cluster,
        });
        Notify.success({
          title: `Success`,
          description: `Upload & deploy project finished successfully!`,
        });
        return true;
      } catch (error) {
        setUploadAndDeployError(true);
      } finally {
        setIsUploadingAndDeploying(false);
      }
    }

    return Promise.resolve(false);
  };

  return {
    authenticate,
    clusters,
    isLoadingClusters,
    isUploadingAndDeploying,
    uploadAndDeployError,
    fetchClusters,
    setAuthenticatingStatus,
    uploadAndDeployProject,
    setUploadAndDeployData,
    resetModal,
  };
};
